/* global google */
import React from "react";

import {GoogleMap, withGoogleMap, Marker, withScriptjs} from "react-google-maps";
import {Region} from "./components";
import {compose, withProps} from "recompose";
import Location from "./components/Location";

function gmap_url(key) {
  let url = 'https://maps.googleapis.com/maps/api/js?v=quarterly&libraries=geometry';
  if (key) {
    url += `&key=${key}`
  }
  return url;
}

export default compose(
  withProps({
    googleMapURL: gmap_url(process.env.REACT_APP_GOOGLE_MAP_KEY),
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div id="map-container" />,
  }),
  withScriptjs,
  withGoogleMap
)(props => {
  let options = {
    mapTypeControl: false,
    streetViewControl: false,
    zoomControlOptions: {position: google.maps.ControlPosition.LEFT_CENTER},
  };
  if (props.onDragPolygon === undefined) {
    options.fullscreenControl = false;
  } else {
    options.fullscreenControlOptions = {position: google.maps.ControlPosition.LEFT_CENTER};
  }
  return <GoogleMap
    ref={props.onMapLoad}
    defaultZoom={props.zoom}
    defaultCenter={props.center}
    mapTypeId={props.mapTypeId}
    options={options}
    onClick={props.onMapClick}
  >
    <Marker {...props.marker}/>
    {props.polygons.map(polygon => (
      <Region key={polygon.key} {...polygon} />
    ))}
    {props.points.map(point => (
      <Location key={point.key} {...point} />
    ))}
  </GoogleMap>;
});
